import { render, staticRenderFns } from "./UserDetailsInfoCard.vue?vue&type=template&id=8d7110f6&"
import script from "./UserDetailsInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserDetailsInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports